import React from 'react';

import { Tooltip, Typography, useTheme } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';

import IconBorder from 'components/shared/IconBorder';
import HorizontalContent from 'components/shared/HorizontalContent';
import { StyledIconButton } from 'components/shared/MuiExtensions';

import { Colors } from 'typings';
import { Call as CallIcon, ContactPhone as ContactPhoneIcon } from '@material-ui/icons';

interface CallLeadProps {
  onClick: (event: any) => void;
  lead: string;
  disable: boolean;
  isCallCenterRoutingEnabled: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
}));

const CallLead = ({ onClick, lead, disable, isCallCenterRoutingEnabled }: CallLeadProps) => {
  const classes = useStyles();
  const theme = useTheme();

  const callLeadButton = (
    <StyledIconButton onClick={onClick} disabled={disable}>
      <IconBorder boxShadow backgroundColor={disable ? Colors.LIGHT_GRAY : undefined}>
        {isCallCenterRoutingEnabled ? (
          <ContactPhoneIcon
            htmlColor={disable ? Colors.MEDIUM_GRAY : theme.palette.background.green}
          />
        ) : (
          <CallIcon htmlColor={disable ? Colors.MEDIUM_GRAY : theme.palette.background.green} />
        )}
      </IconBorder>
    </StyledIconButton>
  );

  return (
    <div className={classes.wrapper}>
      <HorizontalContent>
        <Typography variant="subtitle1">Call {lead}</Typography>
        {isCallCenterRoutingEnabled && (
          <Tooltip title="Purple - callconnect lead">{callLeadButton}</Tooltip>
        )}
        {!isCallCenterRoutingEnabled && callLeadButton}
      </HorizontalContent>
    </div>
  );
};

export default CallLead;
